/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostPressReleaseWordFileSuccessResponseData,
    PostPressReleaseWordFileSuccessResponseDataFromJSON,
    PostPressReleaseWordFileSuccessResponseDataFromJSONTyped,
    PostPressReleaseWordFileSuccessResponseDataToJSON,
} from './PostPressReleaseWordFileSuccessResponseData';

/**
 * POST /press_release/{release_id}/word_file
 * @export
 * @interface PostPressReleaseWordFileResponse
 */
export interface PostPressReleaseWordFileResponse {
    /**
     * 
     * @type {number}
     * @memberof PostPressReleaseWordFileResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof PostPressReleaseWordFileResponse
     */
    message: string;
    /**
     * 
     * @type {PostPressReleaseWordFileSuccessResponseData}
     * @memberof PostPressReleaseWordFileResponse
     */
    data: PostPressReleaseWordFileSuccessResponseData;
}

export function PostPressReleaseWordFileResponseFromJSON(json: any): PostPressReleaseWordFileResponse {
    return PostPressReleaseWordFileResponseFromJSONTyped(json, false);
}

export function PostPressReleaseWordFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseWordFileResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PostPressReleaseWordFileSuccessResponseDataFromJSON(json['data']),
    };
}

export function PostPressReleaseWordFileResponseToJSON(value?: PostPressReleaseWordFileResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PostPressReleaseWordFileSuccessResponseDataToJSON(value.data),
    };
}

